import Vue from 'vue'
import { Notyf } from 'notyf'

Vue.prototype.$notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top'
  }
})
